/* eslint-disable no-undef */
translationString.directDeposit.directDepositCompleteExplanation = translationString.directDeposit.directDepositCompleteExplanation.replace(
    '#1',
    translationString.urlList.explanation_terms_url
);
translationString.directDeposit.directDepositTermsAndConditions = translationString.directDeposit.directDepositTermsAndConditions.replace(
    '#1',
    translationString.urlList.agreement_terms_url
);
translationString.communication.SMSTermsAndConditions = translationString.communication.SMSTermsAndConditions.replace(
    '#1',
    translationString.urlList.comm_agreement_terms_url
);

if(translationString.privacy.retailPrivacyDescription && translationString.privacy.retailPrivacyDescription !== ''){
    translationString.privacy.retailPrivacyDescription = translationString.privacy.retailPrivacyDescription.replace(
        '#1',
        translationString.urlList.privacy_retailPrivacyNotice_url
    );
}

translationString.personal.show = 'show';
translationString.personal.hide = 'hide';

export const Translations = translationString;
